import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { useAppId } from '../context/AppIdContext';
import '../style/adminList.css'
import '../style/saktiKendra.css'
import Header from '../component/header';

const BASE_URL = process.env.REACT_APP_BASE_URL;

const ShaktiKendraList = () => {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [searchTerm, setSearchTerm] = useState("");

    // --- Mobile Search State ---
    const [isMobileSearchOpen, setIsMobileSearchOpen] = useState(false);

    // --- Add Shakti Kendra States ---
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [boothListAPI, setBoothListAPI] = useState([]);
    const [selectedBooths, setSelectedBooths] = useState([]);
    const [modalStep, setModalStep] = useState(1); // 1: Select Booths, 2: Enter Details
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [formData, setFormData] = useState({ name: '', mobile_no: '' });
    const [mobileError, setMobileError] = useState("");

    // --- Edit Shakti Kendra State ---
    const [isEditModalOpen, setIsEditModalOpen] = useState(false);
    const [editModalStep, setEditModalStep] = useState(1);
    const [isEditing, setIsEditing] = useState(false);
    const [editFormData, setEditFormData] = useState({
        user_id: '',
        name: '',
        mobile_no: '',
        booth_list: []
    });
    const [editMobileError, setEditMobileError] = useState("");

    // --- Profile Detail Modal State ---
    const [selectedUser, setSelectedUser] = useState(null);

    const { appId, userId, language } = useAppId();
    const navigate = useNavigate();

    const lang = language || 'en';

    // Translation dictionary
    const t = {
        en: {
            title: "Shakti Kendra Pramukh",
            subtitle: "Manage shakti kendra administrators and assigned booths.",
            addBtn: "Add Shakti Kendra",
            cancelBtn: "Cancel",
            backBtn: "Back",
            doneBtn: "Done",
            submitBtn: "Add Shakti Kendra",
            addingBtn: "Adding...",
            updateBtn: "Update Shakti Kendra",
            updatingBtn: "Updating...",
            nextBtn: "Next: Enter Details",
            viewProfile: "View Profile",
            addModalTitle: "Add Shakti Kendra",
            selectBoothsTitle: "Select Booths",
            enterDetailsTitle: "Enter Details",
            editModalTitle: "Edit Shakti Kendra",
            nameLabel: "Full Name",
            mobileLabel: "Mobile Number",
            boothsAssigned: "Booths Assigned",
            selectedLabel: "Selected",
            fillAllFields: "Please fill all details and select at least one booth.",
            validMobile: "Please enter a valid 10-digit mobile number",
            mobileRequired: "Mobile number is required",
            mobileLength: "Mobile number must be 10 digits",
            mobileNumeric: "Mobile number must contain only digits",
            mobileInvalid: "Please enter a valid Indian mobile number (starts with 6,7,8,9)",
            addSuccess: "Shakti Kendra Added Successfully",
            updateSuccess: "Updated successfully!",
            invalidMobile: "Invalid mobile no",
            searchPlaceholder: "Search by name or mobile...",
            noRecordsFound: "No records found matching",
            loading: "Loading Data...",
            sendWhatsapp: "Send Responsibility in Whatsapp",
            sendSMS: "Send Responsibility in SMS",
            active: "ACTIVE",
            notActive: "NOT ACTIVE",
            boothLabel: "Booth No. :",
            error: "Error",
            failed: "Failed: ",
            addError: "Error adding user",
            updateError: "Error updating user",
            // Delete Specifics
            deleteConfirm: "Are you sure you want to delete this Shakti Kendra Pramukh?",
            deleteSuccess: "User deleted successfully!",
            deleteFailed: "Failed to delete user.",
            deleteError: "Error deleting user.",
            userIdMissing: "Error: User ID is missing."
        },

        hi: {
            title: "शक्ति केंद्र प्रमुख",
            subtitle: "शक्ति केंद्र प्रशासकों और निर्धारित बूथों का प्रबंधन करें।",
            addBtn: "शक्ति केंद्र जोड़ें",
            cancelBtn: "रद्द करें",
            backBtn: "वापस",
            doneBtn: "पूर्ण",
            submitBtn: "शक्ति केंद्र जोड़ें",
            addingBtn: "जोड़ा जा रहा है...",
            updateBtn: "शक्ति केंद्र अपडेट करें",
            updatingBtn: "अपडेट किया जा रहा है...",
            nextBtn: "अगला: विवरण दर्ज करें",
            viewProfile: "प्रोफाइल देखें",
            addModalTitle: "शक्ति केंद्र जोड़ें",
            selectBoothsTitle: "बूथ चुनें",
            enterDetailsTitle: "विवरण दर्ज करें",
            editModalTitle: "शक्ति केंद्र संपादित करें",
            nameLabel: "पूरा नाम",
            mobileLabel: "मोबाइल नंबर",
            boothsAssigned: "निर्धारित बूथ",
            selectedLabel: "चयनित",
            fillAllFields: "कृपया सभी विवरण भरें और कम से कम एक बूथ चुनें।",
            validMobile: "कृपया 10 अंकों का मोबाइल नंबर दर्ज करें।",
            mobileRequired: "मोबाइल नंबर आवश्यक है",
            mobileLength: "मोबाइल नंबर 10 अंकों का होना चाहिए",
            mobileNumeric: "मोबाइल नंबर में केवल अंक होने चाहिए",
            mobileInvalid: "कृपया एक वैध भारतीय मोबाइल नंबर दर्ज करें (6,7,8,9 से शुरू)",
            addSuccess: "शक्ति केंद्र सफलतापूर्वक जोड़ा गया",
            updateSuccess: "सफलतापूर्वक अपडेट किया गया!",
            invalidMobile: "अमान्य मोबाइल नंबर",
            searchPlaceholder: "नाम या मोबाइल से खोजें...",
            noRecordsFound: "कोई रिकॉर्ड नहीं मिला",
            loading: "डेटा लोड हो रहा है...",
            sendWhatsapp: "व्हाट्सएप पर जिम्मेदारी भेजें",
            sendSMS: "एसएमएस पर जिम्मेदारी भेजें",
            active: "सक्रिय",
            notActive: "निष्क्रिय",
            boothLabel: "बूथ नंबर :",
            error: "त्रुटि",
            failed: "विफल: ",
            addError: "उपयोगकर्ता जोड़ने में त्रुटि",
            updateError: "उपयोगकर्ता अपडेट करने में त्रुटि",
            // Delete Specifics
            deleteConfirm: "क्या आप वाकई इस शक्ति केंद्र प्रमुख को हटाना चाहते हैं?",
            deleteSuccess: "उपयोगकर्ता सफलतापूर्वक हटा दिया गया!",
            deleteFailed: "उपयोगकर्ता को हटाने में विफल।",
            deleteError: "उपयोगकर्ता को हटाने में त्रुटि।",
            userIdMissing: "त्रुटि: उपयोगकर्ता आईडी गायब है।"
        },

        gu: {
            title: "શક્તિ કેન્દ્ર પ્રમુખ",
            subtitle: "શક્તિ કેન્દ્ર સંચાલકો અને સોંપાયેલ બૂથનું સંચાલન કરો.",
            addBtn: "શક્તિ કેન્દ્ર ઉમેરો",
            cancelBtn: "રદ કરો",
            backBtn: "પાછળ",
            doneBtn: "પૂર્ણ",
            submitBtn: "શક્તિ કેન્દ્ર ઉમેરો",
            addingBtn: "ઉમેરાઈ રહ્યું છે...",
            updateBtn: "શક્તિ કેન્દ્ર અપડેટ કરો",
            updatingBtn: "અપડેટ થઈ રહ્યું છે...",
            nextBtn: "આગળ: વિગતો દાખલ કરો",
            viewProfile: "પ્રોફાઇલ જુઓ",
            addModalTitle: "શક્તિ કેન્દ્ર ઉમેરો",
            selectBoothsTitle: "બૂથ પસંદ કરો",
            enterDetailsTitle: "વિગતો દાખલ કરો",
            editModalTitle: "શક્તિ કેન્દ્ર સંપાદિત કરો",
            nameLabel: "પૂરું નામ",
            mobileLabel: "મોબાઇલ નંબર",
            boothsAssigned: "સોંપાયેલ બૂથ",
            selectedLabel: "પસંદ કરેલ",
            fillAllFields: "કૃપા કરીને બધી વિગતો ભરો અને ઓછામાં ઓછું એક બૂથ પસંદ કરો.",
            validMobile: "કૃપા કરીને 10 અંકનો મોબાઇલ નંબર દાખલ કરો.",
            mobileRequired: "મોબાઇલ નંબર જરૂરી છે",
            mobileLength: "મોબાઇલ નંબર 10 અંકનો હોવો જોઈએ",
            mobileNumeric: "મોબાઇલ નંબરમાં માત્ર અંકો હોવા જોઈએ",
            mobileInvalid: "કૃપા કરીને માન્ય ભારતીય મોબાઇલ નંબર દાખલ કરો (6,7,8,9 થી શરૂ)",
            addSuccess: "શક્તિ કેન્દ્ર સફળતાપૂર્વક ઉમેરાયું",
            updateSuccess: "સફળતાપૂર્વક અપડેટ થયું!",
            invalidMobile: "અમાન્ય મોબાઇલ નંબર",
            searchPlaceholder: "નામ અથવા મોબાઇલથી શોધો...",
            noRecordsFound: "કોઈ રેકોર્ડ મળ્યો નથી",
            loading: "ડેટા લોડ થઈ રહ્યો છે...",
            sendWhatsapp: "વોટ્સએપ પર જવાબદારી મોકલો",
            sendSMS: "એસએમએસ પર જવાબદારી મોકલો",
            active: "સક્રિય",
            notActive: "નિષ્ક્રિય",
            boothLabel: "બૂથ નંબર :",
            error: "ભૂલ",
            failed: "નિષ્ફળ: ",
            addError: "વપરાશકર્તા ઉમેરવામાં ભૂલ",
            updateError: "વપરાશકર્તા અપડેટ કરવામાં ભૂલ",
            // Delete Specifics
            deleteConfirm: "શું તમે ખરેખર આ શક્તિ કેન્દ્ર પ્રમુખને કાઢી નાખવા માંગો છો?",
            deleteSuccess: "વપરાશકર્તા સફળતાપૂર્વક કાઢી નાખવામાં આવ્યો!",
            deleteFailed: "વપરાશકર્તા કાઢી નાખવામાં નિષ્ફળ.",
            deleteError: "વપરાશકર્તા કાઢી નાખવામાં ભૂલ.",
            userIdMissing: "ભૂલ: વપરાશકર્તા ID ગુમ થયેલ છે."
        }
    };

    const txt = t[lang];

    // Mobile number validation function
    const validateMobileNumber = (number) => {
        if (!number) {
            return { isValid: false, message: txt.mobileRequired };
        }
        if (!/^\d{10}$/.test(number)) {
            return { isValid: false, message: txt.mobileLength };
        }
        if (!/^\d+$/.test(number)) {
            return { isValid: false, message: txt.mobileNumeric };
        }
        const firstDigit = number.charAt(0);
        if (!['6', '7', '8', '9'].includes(firstDigit)) {
            return { isValid: false, message: txt.mobileInvalid };
        }
        return { isValid: true, message: "" };
    };

    // --- Fetch Data ---
    useEffect(() => {
        if (appId) {
            fetchData();
        }
    }, [appId]);

    const fetchData = async () => {
        setLoading(true);
        try {
            const response = await axios.post(`${BASE_URL}/api/dis_saktikendra`, {
                app_id: appId
            });

            if (response.data.success) {
                setData(response.data.data.result || []);
            }
        } catch (error) {
            console.error("Error fetching data:", error);
        } finally {
            setLoading(false);
        }
    };

    // --- Fetch Booths for Selection ---
    const handleOpenModal = async () => {
        setIsModalOpen(true);
        setModalStep(1);
        setSelectedBooths([]);
        setFormData({ name: '', mobile_no: '' });
        setMobileError("");
        try {
            const response = await axios.post(`${BASE_URL}/api/dis_booth_list_for_sakti_creation`, {
                app_id: appId,
                type: "SP"
            });
            if (response.data.success) {
                setBoothListAPI(response.data.data.result || []);
            }
        } catch (error) {
            console.error("Error fetching booths:", error);
        }
    };

    const toggleBoothSelection = (boothNo) => {
        const bStr = String(boothNo).trim();
        setSelectedBooths(prev =>
            prev.includes(bStr)
                ? prev.filter(b => b !== bStr)
                : [...prev, bStr]
        );
    };

    const handleMobileChange = (e, isEdit = false) => {
        const value = e.target.value;
        const numericValue = value.replace(/[^0-9]/g, '');
        const limitedValue = numericValue.slice(0, 10);

        if (isEdit) {
            setEditFormData(prev => ({ ...prev, mobile_no: limitedValue }));
            if (editMobileError) setEditMobileError("");
            if (limitedValue.length === 10) {
                const validation = validateMobileNumber(limitedValue);
                if (!validation.isValid) {
                    setEditMobileError(validation.message);
                } else {
                    setEditMobileError("");
                }
            } else if (limitedValue.length > 0 && limitedValue.length < 10) {
                setEditMobileError(txt.mobileLength);
            }
        } else {
            setFormData(prev => ({ ...prev, mobile_no: limitedValue }));
            if (mobileError) setMobileError("");
            if (limitedValue.length === 10) {
                const validation = validateMobileNumber(limitedValue);
                if (!validation.isValid) {
                    setMobileError(validation.message);
                } else {
                    setMobileError("");
                }
            } else if (limitedValue.length > 0 && limitedValue.length < 10) {
                setMobileError(txt.mobileLength);
            }
        }
    };

    const handleAddUser = async (e) => {
        e.preventDefault();

        // Validate mobile number
        const validation = validateMobileNumber(formData.mobile_no);
        if (!formData.name || !formData.mobile_no || selectedBooths.length === 0) {
            alert(txt.fillAllFields);
            return;
        }
        if (!validation.isValid) {
            alert(validation.message);
            setMobileError(validation.message);
            return;
        }

        setIsSubmitting(true);
        try {
            const formattedBoothList = selectedBooths.join(',') + ",";
            const formattedPrimaryBooth = selectedBooths[0] + ",";

            const payload = {
                app_id: appId,
                name: formData.name,
                mobile_no: formData.mobile_no,
                user_type: "SP",
                booth_no: formattedPrimaryBooth,
                booth_list: formattedBoothList,
                create_by: userId || "Admin"
            };

            const response = await axios.post(`${BASE_URL}/api/insert_user`, payload);
            if (response.data.success && response.data.data && response.data.data.Success == "1") {
                alert(txt.addSuccess);
                setIsModalOpen(false);
                setFormData({ name: '', mobile_no: '' });
                setMobileError("");
                fetchData();
            } else {
                alert("Mobile number already exists.");
            }
        } catch (error) {
            console.error(error);
            alert(txt.addError);
        } finally {
            setIsSubmitting(false);
        }
    };

    const getBoothArray = (boothString) => {
        if (!boothString) return [];
        const rawArray = boothString.split(',').map(b => String(b).trim()).filter(b => b !== '');
        return [...new Set(rawArray)];
    };

    const handleEditClick = async () => {
        if (selectedUser) {
            const currentBooths = getBoothArray(selectedUser.booth_no);
            setEditFormData({
                user_id: selectedUser.user_id || selectedUser.id,
                name: selectedUser.name,
                mobile_no: selectedUser.mobile_no,
                booth_list: currentBooths
            });
            setEditMobileError("");
            setSelectedUser(null);
            setEditModalStep(1);
            setIsEditModalOpen(true);

            if (boothListAPI.length === 0) {
                try {
                    const response = await axios.post(`${BASE_URL}/api/dis_booth_list_for_sakti_creation`, {
                        app_id: appId,
                        type: "SP"
                    });
                    if (response.data.success) {
                        setBoothListAPI(response.data.data.result || []);
                    }
                } catch (error) {
                    console.error("Error fetching booths:", error);
                }
            }
        }
    };

    const handleEditInputChange = (e) => {
        const { name, value } = e.target;
        if (name === 'mobile_no') {
            handleMobileChange(e, true);
        } else {
            setEditFormData(prev => ({ ...prev, [name]: value }));
        }
    };

    const handleUpdateSubmit = async (e) => {
        e.preventDefault();

        // Validate mobile number
        const validation = validateMobileNumber(editFormData.mobile_no);
        if (!editFormData.name || !editFormData.mobile_no || editFormData.booth_list.length === 0) {
            alert(txt.fillAllFields);
            return;
        }
        if (!validation.isValid) {
            alert(validation.message);
            setEditMobileError(validation.message);
            return;
        }

        setIsEditing(true);

        const formattedBoothList = editFormData.booth_list.join(',') + ",";
        const formattedPrimaryBooth = editFormData.booth_list[0] + ",";

        const payload = {
            user_id: editFormData.user_id,
            app_id: appId,
            name: editFormData.name,
            mobile_no: editFormData.mobile_no,
            user_type: "SP",
            booth_no: formattedPrimaryBooth,
            booth_list: formattedBoothList,
            create_by: userId
        };

        try {
            const response = await axios.post(`${BASE_URL}/api/update_user`, payload);
            if (response.data.success && response.data.data && response.data.data.Success == "1") {
                alert(txt.updateSuccess);
                setIsEditModalOpen(false);
                setEditMobileError("");
                fetchData();
            } else {
                alert(response.data.data?.Message || txt.invalidMobile);
            }
        } catch (error) {
            console.error("Axios Error:", error);
            alert(txt.updateError);
        } finally {
            setIsEditing(false);
        }
    };

    // --- NEW: Delete Shakti Kendra Logic ---
    const handleDeleteAdmin = async (id) => {
        if (!id) {
            alert(txt.userIdMissing);
            return;
        }

        if (window.confirm(txt.deleteConfirm)) {
            try {
                const response = await axios.post(`${BASE_URL}/api/dlt_user`, {
                    app_id: appId,
                    user_id: id,
                    delete_by: userId
                });

                if (response.data.success || response.data.Success == "1" || (response.data.data && response.data.data.Success == "1")) {
                    alert(txt.deleteSuccess);
                    setSelectedUser(null); // Close the profile modal
                    fetchData();           // Refresh the list
                } else {
                    alert(response.data.message || response.data.Message || response.data.data?.Message || txt.deleteFailed);
                }
            } catch (error) {
                console.error("Delete Error:", error);
                alert(txt.deleteError);
            }
        }
    };

    const filteredData = data.filter(item => {
        if (!searchTerm) return true;
        const lowerSearch = searchTerm.toLowerCase();
        return (
            (item.name && item.name.toLowerCase().includes(lowerSearch)) ||
            (item.mobile_no && item.mobile_no.includes(lowerSearch))
        );
    });

    if (loading) {
        return (
            <div className="loader-wrapper">
                <div className="spinner"></div>
                <p className="loader-text">{txt.loading}</p>
                <style jsx>{`
                    .loader-wrapper { display: flex; flex-direction: column; justify-content: center; align-items: center; min-height: 60vh; width: 100%; }
                    .spinner { width: 50px; height: 50px; border: 4px solid #E5E7EB; border-top: 4px solid #2563EB; border-radius: 50%; animation: spin 1s linear infinite; margin-bottom: 16px; box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1); }
                    .loader-text { color: #6B7280; font-weight: 500; font-size: 1.1rem; animation: pulse 1.5s ease-in-out infinite; }
                    @keyframes spin { 0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); } }
                    @keyframes pulse { 0%, 100% { opacity: 1; } 50% { opacity: 0.5; } }
                `}</style>
            </div>
        );
    }

    return (
        <>
            {isModalOpen && (
                <div className="modal-overlay">
                    <div className="sk-add-modal">
                        <div className="sk-add-header">
                            <div>

                                <h2 className="sk-add-title">
                                    {modalStep === 1 ? txt.selectBoothsTitle : txt.enterDetailsTitle}
                                </h2>
                            </div>
                            <button className="sk-add-close" onClick={() => setIsModalOpen(false)}>✕</button>
                        </div>



                        {modalStep === 1 ? (
                            <div className="sk-add-body">
                                <div className="sk-add-selected-bar">
                                    <span className="sk-add-selected-label">{txt.selectedLabel}</span>
                                    <span className="sk-add-selected-value">
                                        {selectedBooths.length > 0 ? selectedBooths.join(', ') : '—'}
                                    </span>
                                    <span className="sk-add-selected-count">{selectedBooths.length}</span>
                                </div>

                                <div className="sk-add-booth-grid">
                                    {boothListAPI.map(b => {
                                        const bStr = String(b.booth_no).trim();
                                        const isSelected = selectedBooths.includes(bStr);
                                        return (
                                            <div
                                                key={b.booth_no}
                                                className={`sk-add-booth-tile ${isSelected ? 'selected' : ''}`}
                                                onClick={() => toggleBoothSelection(bStr)}
                                            >
                                                {b.booth_no}
                                                {Number(b.is_assigned) === 1 && <span className="sk-add-assigned-dot"></span>}
                                            </div>
                                        );
                                    })}
                                </div>

                                <div className="sk-add-footer">
                                    <button
                                        className="sk-add-btn-primary"
                                        onClick={() => setModalStep(2)}
                                        disabled={selectedBooths.length === 0}
                                    >
                                        {txt.nextBtn}
                                        <svg width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2.2" viewBox="0 0 24 24">
                                            <path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" />
                                        </svg>
                                    </button>
                                </div>
                            </div>
                        ) : (
                            <form onSubmit={handleAddUser} className="sk-add-body">
                                <div className="sk-add-form-group">
                                    <label className="sk-add-label">{txt.nameLabel}</label>
                                    <input
                                        type="text"
                                        className="sk-add-input"
                                        required
                                        value={formData.name}
                                        onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                                        placeholder={txt.nameLabel}
                                    />
                                </div>

                                <div className="sk-add-form-group">
                                    <label className="sk-add-label">{txt.mobileLabel}</label>
                                    <input
                                        type="text"
                                        className={`sk-add-input ${mobileError ? 'error' : ''}`}
                                        required
                                        maxLength="10"
                                        value={formData.mobile_no}
                                        onChange={(e) => handleMobileChange(e, false)}
                                        placeholder="9876543210"
                                    />
                                    {mobileError && <div className="sk-add-error-text">{mobileError}</div>}
                                </div>

                                <div className="sk-add-footer sk-add-footer-split">
                                    <button type="submit" className="sk-add-btn-primary" disabled={isSubmitting} style={{ maxWidth: '200px' }}>
                                        {isSubmitting ? txt.addingBtn : txt.submitBtn}
                                    </button>
                                </div>
                            </form>
                        )}
                    </div>
                </div>
            )}

            {isEditModalOpen && (
                <div className="modal-overlay">
                    <div className="sk-edit-modal">
                        <div className="sk-edit-header">
                            <div>
                              
                                <h2 className="sk-edit-title">{txt.editModalTitle}</h2>
                            </div>
                            <button className="sk-edit-close" onClick={() => setIsEditModalOpen(false)}>✕</button>
                        </div>

                        {editModalStep === 1 ? (
                            <form onSubmit={handleUpdateSubmit} className="sk-edit-body">
                                <div className="sk-edit-form-group">
                                    <label className="sk-edit-label">{txt.boothsAssigned}</label>
                                    <button
                                        type="button"
                                        className="sk-edit-booth-summary"
                                        onClick={() => setEditModalStep(2)}
                                    >
                                        <span className="sk-edit-booth-summary-text">
                                            {editFormData.booth_list.length > 0
                                                ? editFormData.booth_list.join(', ')
                                                : 'Select booths'}
                                        </span>
                                        <span className="sk-edit-booth-summary-count">
                                            {editFormData.booth_list.length}
                                        </span>
                                        <svg width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2.2" viewBox="0 0 24 24">
                                            <path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" />
                                        </svg>
                                    </button>
                                </div>

                                <div className="sk-edit-form-group">
                                    <label className="sk-edit-label">{txt.nameLabel}</label>
                                    <input
                                        type="text"
                                        name="name"
                                        className="sk-edit-input"
                                        value={editFormData.name}
                                        onChange={handleEditInputChange}
                                        required
                                        placeholder={txt.nameLabel}
                                    />
                                </div>

                                <div className="sk-edit-form-group">
                                    <label className="sk-edit-label">{txt.mobileLabel}</label>
                                    <input
                                        type="text"
                                        name="mobile_no"
                                        className={`sk-edit-input ${editMobileError ? 'error' : ''}`}
                                        value={editFormData.mobile_no}
                                        onChange={handleEditInputChange}
                                        maxLength="10"
                                        required
                                        placeholder="9876543210"
                                    />
                                    {editMobileError && <div className="sk-edit-error-text">{editMobileError}</div>}
                                </div>

                                <div className="sk-edit-footer">
                                    <button type="submit" className="sk-edit-btn-primary" disabled={isEditing}>
                                        {isEditing ? txt.updatingBtn : txt.updateBtn}
                                    </button>
                                </div>
                            </form>
                        ) : (
                            <div className="sk-edit-body">
                                <div className="sk-edit-selected-bar">
                                    <span className="sk-edit-selected-label">{txt.selectedLabel}</span>
                                    <span className="sk-edit-selected-value">
                                        {editFormData.booth_list.length > 0 ? editFormData.booth_list.join(', ') : '—'}
                                    </span>
                                    <span className="sk-edit-selected-count">{editFormData.booth_list.length}</span>
                                </div>

                                <div className="sk-edit-booth-grid">
                                    {boothListAPI.map(b => {
                                        const bStr = String(b.booth_no).trim();
                                        const isSelected = editFormData.booth_list.includes(bStr);
                                        return (
                                            <div
                                                key={b.booth_no}
                                                className={`sk-edit-booth-tile ${isSelected ? 'selected' : ''}`}
                                                onClick={() => setEditFormData(prev => ({
                                                    ...prev,
                                                    booth_list: isSelected
                                                        ? prev.booth_list.filter(x => x !== bStr)
                                                        : [...prev.booth_list, bStr]
                                                }))}
                                            >
                                                {b.booth_no}
                                                {Number(b.is_assigned) === 1 && <span className="sk-edit-assigned-dot"></span>}
                                            </div>
                                        );
                                    })}
                                </div>

                                <div className="sk-edit-footer">
                                    <button className="sk-edit-btn-primary" onClick={() => setEditModalStep(1)}>
                                        {txt.doneBtn}
                                    </button>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            )}

            {/* Profile Detail Modal */}
            {selectedUser && (
                <div className="modal-overlay" onClick={() => setSelectedUser(null)}>
                    <div className="profile-detail-container" onClick={(e) => e.stopPropagation()}>
                        <button className="profile-close-btn" onClick={() => setSelectedUser(null)}>
                            <svg width="24" height="24" fill="none" stroke="white" strokeWidth="2" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" /></svg>
                        </button>
                        <div className="profile-detail-card">
                            <div className="profile-avatar-wrapper">
                                <div className="profile-avatar-bg">
                                    <img src={selectedUser.photo ? selectedUser.photo : `https://ui-avatars.com/api/?name=${encodeURIComponent(selectedUser.name)}&background=e5e5e5&color=a3a3a3`} alt={selectedUser.name} />
                                </div>
                            </div>
                            <div className="profile-content">
                                <h2 className="profile-name">{selectedUser.name}</h2>
                                <p className="profile-mobile">{selectedUser.mobile_no}</p>
                                <div className="profile-big-btns">
                                    <a href={`https://wa.me/91${selectedUser.mobile_no}`} target="_blank" rel="noreferrer" className="btn-resp btn-wa">{txt.sendWhatsapp}</a>
                                    <a href={`sms:${selectedUser.mobile_no}`} className="btn-resp btn-sms-big">{txt.sendSMS}</a>
                                </div>
                            </div>
                            <div className="profile-bottom-bar" style={{ display: 'flex', justifyContent: 'space-evenly', background: '#213555', padding: '10px', borderRadius: '0 0 20px 20px' }}>
                                <a href={`tel:${selectedUser.mobile_no}`} className="btm-icon-wrapper">
                                    <div className="icon-transparent" style={{ color: '#0ea5e9' }}>
                                        <svg width="24" height="24" fill="currentColor" viewBox="0 0 24 24"><path d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z" /></svg>
                                    </div>
                                </a>
                                <div className="divider"></div>
                                <a href={`https://wa.me/91${selectedUser.mobile_no}`} target="_blank" rel="noreferrer" className="btm-icon-wrapper">
                                    <div className="icon-transparent" style={{ color: '#22c55e' }}>
                                        <svg width="24" height="24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24"><path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z"></path></svg>
                                    </div>
                                </a>
                                <div className="divider"></div>
                                <a href={`sms:${selectedUser.mobile_no}`} className="btm-icon-wrapper">
                                    <div className="icon-transparent" style={{ color: '#3b82f6', position: 'relative' }}>
                                        <svg width="24" height="24" fill="currentColor" viewBox="0 0 24 24"><path d="M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-2 10H6v-2h12v2zm0-3H6V7h12v2z" /></svg>
                                        <span style={{ position: 'absolute', fontSize: '7px', color: 'white', fontWeight: 'bold', marginTop: '-2px' }}></span>
                                    </div>
                                </a>
                                <div className="divider"></div>
                                <button className="btm-icon-wrapper" onClick={handleEditClick} style={{ background: 'none', border: 'none', padding: 0 }}>
                                    <div className="icon-transparent" style={{ color: '#f59e0b' }}>
                                        <svg width="24" height="24" fill="currentColor" viewBox="0 0 24 24"><path d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34a.9959.9959 0 00-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z" /></svg>
                                    </div>
                                </button>
                                <div className="divider"></div>
                                <button className="btm-icon-wrapper" onClick={() => handleDeleteAdmin(selectedUser.user_id || selectedUser.id)} style={{ color: '#ef4444' }}><svg width="24" height="24" fill="currentColor" viewBox="0 0 24 24"><path d="M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z" /></svg></button>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            <style jsx>{`
                /* --- PROFESSIONAL FILTER CONTAINER --- */
                .filter-container {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    gap: 16px;
                    margin-bottom: 24px;
                    background: transparent;
                }

                .action-group {
                    display: flex;
                    align-items: center;
                    gap: 12px;
                }

                /* Mobile Search Trigger Button */
                .mobile-search-trigger {
                    display: none;
                }
                .close-search-btn {
                    display: none;
                }

                .search-wrapper {
                    position: relative;
                    flex: 1;
                    max-width: 400px;
                }

                .search-icon {
                    position: absolute;
                    left: 14px;
                    top: 50%;
                    transform: translateY(-50%);
                    color: #94a3b8;
                    width: 20px;
                    height: 20px;
                }

                .search-input {
                    width: 100%;
                    padding: 12px 16px 12px 42px;
                    border: 1px solid #e2e8f0;
                    border-radius: 10px;
                    font-size: 14px;
                    color: #1e293b;
                    background-color: #ffffff;
                    outline: none;
                    transition: all 0.2s ease;
                    box-shadow: 0 1px 2px rgba(0,0,0,0.05);
                }

                .search-input:focus {
                    border-color: #2563eb;
                    box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.1);
                }

                .btn-add-user {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    gap: 8px;
                    background-color: #2563eb;
                    color: #ffffff;
                    padding: 12px 20px;
                    border: none;
                    border-radius: 10px;
                    font-size: 14px;
                    font-weight: 600;
                    cursor: pointer;
                    transition: all 0.2s ease;
                    box-shadow: 0 4px 6px -1px rgba(37, 99, 235, 0.2);
                    white-space: nowrap;
                }

                .btn-add-user:hover {
                    background-color: #1d4ed8;
                    transform: translateY(-1px);
                    box-shadow: 0 6px 8px -1px rgba(37, 99, 235, 0.3);
                }

                /* Mobile Optimization for Search Bar */
                @media (max-width: 640px) {
                    .filter-container {
                        flex-direction: column;
                        align-items: stretch;
                        gap: 12px;
                    }
                    
                    /* Hide full search wrapper by default on mobile */
                    .search-wrapper {
                        display: none;
                        width: 100%;
                        max-width: 100%;
                    }
                    
                    /* Show it when state is true */
                    .search-wrapper.mobile-open {
                        display: block;
                    }

                    .search-input {
                        padding-right: 40px; /* Room for close 'X' */
                    }

                    .close-search-btn {
                        display: block;
                        position: absolute;
                        right: 8px;
                        top: 50%;
                        transform: translateY(-50%);
                        background: #f1f5f9;
                        border: none;
                        color: #64748b;
                        padding: 4px;
                        border-radius: 50%;
                        cursor: pointer;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                    }

                    .action-group {
                        width: 100%;
                    }

                    .btn-add-user {
                        flex: 1;
                        height: 46px; /* Match icon button height */
                    }

                    .mobile-search-trigger {
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        background: white;
                        border: 1px solid #e2e8f0;
                        border-radius: 10px;
                        width: 46px;
                        height: 46px;
                        color: #64748b;
                        cursor: pointer;
                        box-shadow: 0 1px 2px rgba(0,0,0,0.05);
                        flex-shrink: 0;
                    }
                    
                    /* Hide trigger when search is open */
                    .mobile-search-trigger.hidden {
                        display: none;
                    }

                    /* Modals adjustments for small phones */
                    .modal-content-box { padding: 0px !important; }
                    .profile-content { padding: 15px 16px 20px 16px; }
                    .btn-resp { font-size: 13px; padding: 12px; }
                    .profile-name { font-size: 18px; }
                    .profile-mobile { font-size: 14px; }
                }
                .blur-background { filter: blur(4px); pointer-events: none; }

                 /* MODAL RESPONSIVE FIXES */
                .modal-overlay { position: fixed; top: 0; left: 0; right: 0; bottom: 0; background: rgba(0, 0, 0, 0.6); display: flex; align-items: center; justify-content: center; z-index: 1000; padding: 20px; box-sizing: border-box; }
                .modal-content-box { background: white; border-radius: 12px; width: 100%; box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1); padding: 0px; box-sizing: border-box; }
                .modal-header { display: flex; justify-content: space-between; align-items: center; border-bottom: 1px solid #e5e7eb; padding-bottom: 15px; margin-bottom: 10px; }
                .modal-header h2 { margin: 0; font-size: 1.25rem; color: #111827; }
                .close-btn-icon { background: none; border: none; cursor: pointer; color: #6b7280; }
                .close-btn-icon:hover { color: #111827; }

                .profile-detail-container { position: relative; width: 100%; max-width: 380px; margin-top: 50px; }
                .profile-close-btn { position: absolute; top: -40px; right: -10px; background: none; border: none; cursor: pointer; padding: 5px; z-index: 10; }
                .profile-detail-card { background: white; border-radius: 20px; display: flex; flex-direction: column; overflow: visible; box-shadow: 0 15px 35px rgba(0,0,0,0.2); }
                .profile-avatar-wrapper { display: flex; justify-content: center; margin-top: -55px; }
                .profile-avatar-bg { width: 110px; height: 110px; background: white; border-radius: 50%; padding: 6px; }
                .profile-avatar-bg img { width: 100%; height: 100%; border-radius: 50%; object-fit: cover; }
                .profile-content { padding: 15px 24px 25px 24px; text-align: center; }
                .profile-name { font-size: 22px; font-weight: 800; color: #111827; text-transform: uppercase; margin: 0; }
                .profile-mobile { font-size: 16px; color: #374151; margin: 8px 0 24px 0; letter-spacing: 0.5px; font-weight: 500; }
                .profile-big-btns { display: flex; flex-direction: column; gap: 12px; }
                .btn-resp { display: flex; align-items: center; justify-content: center; gap: 10px; width: 100%; padding: 14px; border-radius: 50px; color: white; font-weight: 600; text-decoration: none; font-size: 15px; transition: transform 0.2s, box-shadow 0.2s; border: none; box-sizing: border-box; }
                .btn-resp:hover { transform: translateY(-2px); box-shadow: 0 4px 10px rgba(0,0,0,0.15); color: white; }
                .btn-wa { background-color: #4ade80; } .btn-sms-big { background-color: #f59e0b; }
                .profile-bottom-bar { background-color: #213555; border-radius: 0 0 20px 20px; display: flex; justify-content: space-evenly; align-items: center;}
                .divider { width: 1px; height: 24px; background-color: rgba(255, 255, 255, 0.3); }
                .btm-icon-wrapper { background: none; border: none; padding: 0; cursor: pointer; display: flex; align-items: center; justify-content: center; transition: transform 0.2s; }
                .btm-icon-wrapper:hover { transform: scale(1.1); }
                .icon-circle { width: 36px; height: 36px; border-radius: 50%; display: flex; align-items: center; justify-content: center; color: white; }
                .bg-call { background-color: #0ea5e9; } .bg-wa-small { background-color: #22c55e; }
                .icon-transparent { width: 36px; height: 36px; display: flex; align-items: center; justify-content: center; position: relative; }
                .color-sms { color: #3b82f6; } .color-edit { color: #f59e0b; } .color-delete { color: #ef4444; }

                /* --- Premium Add Shakti Kendra Modal --- */
.sk-add-modal {
    background: #ffffff;
    border-radius: 18px;
    width: 100%;
    max-width: 600px;
    box-shadow: 0 20px 60px -12px rgba(15, 23, 42, 0.25), 0 4px 12px rgba(15, 23, 42, 0.08);
    overflow: hidden;
    border: 1px solid rgba(226, 232, 240, 0.8);
}

.sk-add-header {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    padding: 24px 26px 18px 26px;
    background: linear-gradient(180deg, #f8fafc 0%, #ffffff 100%);
    border-bottom: 1px solid #eef1f6;
}

.sk-add-eyebrow {
    display: inline-block;
    font-size: 11px;
    font-weight: 700;
    letter-spacing: 0.08em;
    text-transform: uppercase;
    color: #2563eb;
    background: rgba(37, 99, 235, 0.08);
    padding: 4px 10px;
    border-radius: 20px;
    margin-bottom: 8px;
}

.sk-add-title {
    margin: 0;
    font-size: 20px;
    font-weight: 700;
    color: #0f172a;
    letter-spacing: -0.01em;
}

.sk-add-close {
    background: #f1f5f9;
    border: none;
    width: 32px;
    height: 32px;
    border-radius: 50%;
    color: #64748b;
    cursor: pointer;
    font-size: 14px;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.15s ease;
    flex-shrink: 0;
}

.sk-add-close:hover {
    background: #e2e8f0;
    color: #0f172a;
}

.sk-add-steps {
    display: flex;
    align-items: center;
    padding: 16px 26px 0 26px;
}

.sk-add-step-dot {
    width: 9px;
    height: 9px;
    border-radius: 50%;
    background: #e2e8f0;
    transition: background 0.2s ease;
    flex-shrink: 0;
}

.sk-add-step-dot.active {
    background: #2563eb;
    box-shadow: 0 0 0 4px rgba(37, 99, 235, 0.15);
}

.sk-add-step-line {
    flex: 1;
    height: 2px;
    background: #e2e8f0;
    margin: 0 8px;
}

.sk-add-body {
    padding: 20px 26px 26px 26px;
    display: flex;
    flex-direction: column;
    gap: 16px;
}

.sk-add-selected-bar {
    display: flex;
    align-items: center;
    gap: 10px;
    background: #f8fafc;
    border: 1px solid #eef1f6;
    border-radius: 12px;
    padding: 12px 14px;
}

.sk-add-selected-label {
    font-size: 12px;
    font-weight: 600;
    color: #64748b;
    white-space: nowrap;
}

.sk-add-selected-value {
    font-size: 13px;
    font-weight: 600;
    color: #0f172a;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    flex: 1;
}

.sk-add-selected-count {
    background: #2563eb;
    color: white;
    font-size: 12px;
    font-weight: 700;
    min-width: 22px;
    height: 22px;
    border-radius: 11px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 6px;
}

.sk-add-booth-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(56px, 1fr));
    gap: 8px;
    max-height: 300px;
    overflow-y: auto;
    padding: 4px 2px;
}

.sk-add-booth-tile {
    padding: 11px 6px;
    border: 1.5px solid #e2e8f0;
    border-radius: 10px;
    text-align: center;
    cursor: pointer;
    font-weight: 700;
    font-size: 13px;
    color: #334155;
    background: #ffffff;
    position: relative;
    transition: all 0.15s ease;
}

.sk-add-booth-tile:hover {
    border-color: #93c5fd;
    transform: translateY(-1px);
}

.sk-add-booth-tile.selected {
    background: linear-gradient(135deg, #2563eb, #1d4ed8);
    border-color: #1d4ed8;
    color: white;
    box-shadow: 0 4px 10px rgba(37, 99, 235, 0.3);
}

.sk-add-assigned-dot {
    position: absolute;
    bottom: 5px;
    left: 50%;
    transform: translateX(-50%);
    width: 5px;
    height: 5px;
    border-radius: 50%;
    background: #22c55e;
}

.sk-add-booth-tile.selected .sk-add-assigned-dot {
    background: #bbf7d0;
}

.sk-add-form-group {
    display: flex;
    flex-direction: column;
    gap: 7px;
}

.sk-add-label {
    font-size: 13px;
    font-weight: 600;
    color: #334155;
}

.sk-add-input {
    padding: 12px 14px;
    border-radius: 10px;
    border: 1.5px solid #e2e8f0;
    font-size: 14px;
    color: #0f172a;
    outline: none;
    transition: all 0.15s ease;
    background: #f8fafc;
}

.sk-add-input:focus {
    border-color: #2563eb;
    background: #ffffff;
    box-shadow: 0 0 0 4px rgba(37, 99, 235, 0.1);
}

.sk-add-input.error {
    border-color: #ef4444;
    background: #fef2f2;
}

.sk-add-error-text {
    font-size: 12px;
    font-weight: 500;
    color: #ef4444;
}

.sk-add-footer {
    display: flex;
    justify-content: flex-end;
    margin-top: 6px;
}

.sk-add-footer-split {
    justify-content: space-between;
}

.sk-add-btn-primary {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    background: linear-gradient(135deg, #2563eb, #1d4ed8);
    color: white;
    border: none;
    padding: 13px 22px;
    border-radius: 11px;
    font-weight: 600;
    font-size: 14px;
    cursor: pointer;
    width: 100%;
    box-shadow: 0 6px 16px -4px rgba(37, 99, 235, 0.4);
    transition: all 0.15s ease;
}

.sk-add-footer-split .sk-add-btn-primary {
    width: auto;
    flex: 1;
}

.sk-add-btn-primary:hover:not(:disabled) {
    transform: translateY(-1px);
    box-shadow: 0 8px 20px -4px rgba(37, 99, 235, 0.5);
}

.sk-add-btn-primary:disabled {
    opacity: 0.5;
    cursor: not-allowed;
    box-shadow: none;
}

.sk-add-btn-ghost {
    background: #f1f5f9;
    color: #334155;
    border: none;
    padding: 13px 20px;
    border-radius: 11px;
    font-weight: 600;
    font-size: 14px;
    cursor: pointer;
    transition: all 0.15s ease;
}

.sk-add-btn-ghost:hover {
    background: #e2e8f0;
}

@media (max-width: 640px) {
    .sk-add-header { padding: 20px 18px 14px 18px; }
    .sk-add-body { padding: 16px 18px 20px 18px; }
    .sk-add-title { font-size: 18px; }
}

/* --- Premium Edit Shakti Kendra Modal --- */
.sk-edit-modal {
    background: #ffffff;
    border-radius: 18px;
    width: 100%;
    max-width: 500px;
    box-shadow: 0 20px 60px -12px rgba(15, 23, 42, 0.25), 0 4px 12px rgba(15, 23, 42, 0.08);
    overflow: hidden;
    border: 1px solid rgba(226, 232, 240, 0.8);
}

.sk-edit-header {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    padding: 24px 26px 18px 26px;
    background: linear-gradient(180deg, #eff6ff 0%, #ffffff 100%);
    border-bottom: 1px solid #eef1f6;
}

.sk-edit-eyebrow {
    display: inline-block;
    font-size: 11px;
    font-weight: 700;
    letter-spacing: 0.08em;
    text-transform: uppercase;
    color: #1e3a8a;
    background: rgba(30, 58, 138, 0.08);
    padding: 4px 10px;
    border-radius: 20px;
    margin-bottom: 8px;
}

.sk-edit-title {
    margin: 0;
    font-size: 20px;
    font-weight: 700;
    color: #0f172a;
    letter-spacing: -0.01em;
}

.sk-edit-close {
    background: #f1f5f9;
    border: none;
    width: 32px;
    height: 32px;
    border-radius: 50%;
    color: #64748b;
    cursor: pointer;
    font-size: 14px;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.15s ease;
    flex-shrink: 0;
}

.sk-edit-close:hover {
    background: #e2e8f0;
    color: #0f172a;
}

.sk-edit-body {
    padding: 22px 26px 26px 26px;
    display: flex;
    flex-direction: column;
    gap: 16px;
}

.sk-edit-form-group {
    display: flex;
    flex-direction: column;
    gap: 7px;
}

.sk-edit-label {
    font-size: 13px;
    font-weight: 600;
    color: #334155;
}

.sk-edit-input {
    padding: 12px 14px;
    border-radius: 10px;
    border: 1.5px solid #e2e8f0;
    font-size: 14px;
    color: #0f172a;
    outline: none;
    transition: all 0.15s ease;
    background: #f8fafc;
}

.sk-edit-input:focus {
    border-color: #1e3a8a;
    background: #ffffff;
    box-shadow: 0 0 0 4px rgba(30, 58, 138, 0.1);
}

.sk-edit-input.error {
    border-color: #ef4444;
    background: #fef2f2;
}

.sk-edit-error-text {
    font-size: 12px;
    font-weight: 500;
    color: #ef4444;
}

.sk-edit-booth-summary {
    display: flex;
    align-items: center;
    gap: 10px;
    width: 100%;
    padding: 12px 14px;
    border-radius: 10px;
    border: 1.5px solid #e2e8f0;
    background: #f8fafc;
    cursor: pointer;
    text-align: left;
    color: #64748b;
    transition: all 0.15s ease;
}

.sk-edit-booth-summary:hover {
    border-color: #93c5fd;
    background: #ffffff;
}

.sk-edit-booth-summary-text {
    flex: 1;
    font-size: 13px;
    font-weight: 600;
    color: #0f172a;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.sk-edit-booth-summary-count {
    background: #1e3a8a;
    color: white;
    font-size: 12px;
    font-weight: 700;
    min-width: 22px;
    height: 22px;
    border-radius: 11px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 6px;
    flex-shrink: 0;
}

.sk-edit-selected-bar {
    display: flex;
    align-items: center;
    gap: 10px;
    background: #f8fafc;
    border: 1px solid #eef1f6;
    border-radius: 12px;
    padding: 12px 14px;
}

.sk-edit-selected-label {
    font-size: 12px;
    font-weight: 600;
    color: #64748b;
    white-space: nowrap;
}

.sk-edit-selected-value {
    font-size: 13px;
    font-weight: 600;
    color: #0f172a;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    flex: 1;
}

.sk-edit-selected-count {
    background: #1e3a8a;
    color: white;
    font-size: 12px;
    font-weight: 700;
    min-width: 22px;
    height: 22px;
    border-radius: 11px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 6px;
}

.sk-edit-booth-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(56px, 1fr));
    gap: 8px;
    max-height: 350px;
    overflow-y: auto;
    padding: 4px 2px;
}

.sk-edit-booth-tile {
    padding: 11px 6px;
    border: 1.5px solid #e2e8f0;
    border-radius: 10px;
    text-align: center;
    cursor: pointer;
    font-weight: 700;
    font-size: 13px;
    color: #334155;
    background: #ffffff;
    position: relative;
    transition: all 0.15s ease;
}

.sk-edit-booth-tile:hover {
    border-color: #93c5fd;
    transform: translateY(-1px);
}

.sk-edit-booth-tile.selected {
    background: linear-gradient(135deg, #1e3a8a, #1e40af);
    border-color: #1e3a8a;
    color: white;
    box-shadow: 0 4px 10px rgba(30, 58, 138, 0.3);
}

.sk-edit-assigned-dot {
    position: absolute;
    bottom: 5px;
    left: 50%;
    transform: translateX(-50%);
    width: 5px;
    height: 5px;
    border-radius: 50%;
    background: #22c55e;
}

.sk-edit-booth-tile.selected .sk-edit-assigned-dot {
    background: #bbf7d0;
}

.sk-edit-footer {
    display: flex;
    margin-top: 6px;
}

.sk-edit-btn-primary {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    background: linear-gradient(135deg, #1e3a8a, #1e40af);
    color: white;
    border: none;
    padding: 13px 22px;
    border-radius: 11px;
    font-weight: 600;
    font-size: 14px;
    cursor: pointer;
    width: 100%;
    box-shadow: 0 6px 16px -4px rgba(30, 58, 138, 0.4);
    transition: all 0.15s ease;
}

.sk-edit-btn-primary:hover:not(:disabled) {
    transform: translateY(-1px);
    box-shadow: 0 8px 20px -4px rgba(30, 58, 138, 0.5);
}

.sk-edit-btn-primary:disabled {
    opacity: 0.5;
    cursor: not-allowed;
    box-shadow: none;
}

@media (max-width: 640px) {
    .sk-edit-header { padding: 20px 18px 14px 18px; }
    .sk-edit-body { padding: 18px 18px 22px 18px; }
    .sk-edit-title { font-size: 18px; }
}

            `}</style>

            <div className={`app-container p-4 ${isModalOpen || isEditModalOpen || selectedUser ? 'blur-background' : ''}`}>

                <Header title={txt.title} />

                <div className="filter-container">
                    <div className={`search-wrapper ${isMobileSearchOpen ? 'mobile-open' : ''}`}>
                        <svg className="search-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" /></svg>
                        <input
                            type="text"
                            className="search-input"
                            placeholder={txt.searchPlaceholder}
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                        />
                        <button className="close-search-btn" onClick={() => { setIsMobileSearchOpen(false); setSearchTerm(''); }}>
                            <svg width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" /></svg>
                        </button>
                    </div>

                    <div className="action-group">
                        {!isMobileSearchOpen && (
                            <button className="mobile-search-trigger" onClick={() => setIsMobileSearchOpen(true)}>
                                <svg width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" /></svg>
                            </button>
                        )}
                        <button className="btn-add-user" onClick={handleOpenModal}>
                            <svg width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
                            </svg>
                            {txt.addBtn}
                        </button>
                    </div>
                </div>

                <div className="list-section">
                    <div className="row g-4">
                        {filteredData.length > 0 ? (
                            filteredData.map((item) => {
                                const isActive = item.last_login !== null;
                                const boothList = getBoothArray(item.booth_no);

                                return (
                                    <div
                                        key={item.user_id}
                                        className="col-12 col-md-6 col-xl-4"
                                        onClick={() => navigate('/booth_pramukh_saktikendra', { state: { user_id: item.user_id } })}
                                    >
                                        <div className="sk-card h-100" style={{ cursor: 'pointer' }}>
                                            <div className="card-top-row">
                                                <div className="avatar-box">
                                                    {item.photo ? (
                                                        <img src={item.photo_path} alt={item.name} />
                                                    ) : (
                                                        <svg className="avatar-placeholder" fill="currentColor" viewBox="0 0 24 24"><path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z" /></svg>
                                                    )}
                                                </div>

                                                <div className="card-middle">
                                                    <h3 className="user-name text-black">{item.name}</h3>
                                                    <p className="user-mobile">{item.mobile_no}</p>
                                                    <span className={`status-badge ${isActive ? 'active' : 'inactive'}`}>
                                                        {isActive && <span className="status-dot"></span>}
                                                        {isActive ? txt.active : txt.notActive}
                                                    </span>
                                                </div>

                                                <div className="card-right">
                                                    <button className="action-btn btn-menu" onClick={(e) => { e.stopPropagation(); setSelectedUser(item); }}>⋮</button>
                                                </div>
                                            </div>

                                            <div className="card-bottom-row">
                                                <span className="booth-label">{txt.boothLabel}</span>
                                                <div className="booth-badges">
                                                    {boothList.map((booth, idx) => (
                                                        <span key={idx} className="booth-pill">{booth}</span>
                                                    ))}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                );
                            })
                        ) : (
                            <div className="col-12 text-center text-muted p-5">
                                {txt.noRecordsFound} "{searchTerm}"
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </>
    );
};

export default ShaktiKendraList;